import {useContext} from "react";

import {InteractiveRegionsMapContext} from "../context/InteractiveRegionsMapContext";

export const useInteractiveRegionsMapContext = () => {
    return useContext(InteractiveRegionsMapContext);
};
import {useContext} from "react";

import {InteractiveRegionsMapContext} from "../context/InteractiveRegionsMapContext";

export const useInteractiveRegionsMapContext = () => {
    return useContext(InteractiveRegionsMapContext);
};
